export const RESELLER_PLANS = [
  'custom_partner_essentials',
  'custom_partner_premium',
  'trial_partner',
];
